// TODO: Move this into Shared/Models
import { AuthenticationResult } from '@azure/msal-common';
import { Confirmation } from 'primeng/api';

/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable @typescript-eslint/prefer-namespace-keyword */
export module Models {
  export interface GlobalSearch {
    results: GlobalSearchResult[];
    totalLoanCount: number;
  }

  export interface GlobalSearchResult {
    type?: SearchResultType;
    loanID?: string;
    loanNumber?: string;
    leadNumber?: string;
    leadGUID?: string;
    applicationDate?: Date;
    loanStatus?: string;
    loanAmount?: number;
    propertyStreet?: string;
    propertyCity?: string;
    propertyState?: string;
    propertyZip?: string;
    borrowerFirstName?: string;
    borrowerLastName?: string;
    otherBorrowerNames?: string[];
    dateModified?: Date;
    syncFileDataId?: number;
    syncFileName?: string;
    syncFileDataId2?: number;
    syncFileName2?: string;
  }

  // For the global header search.
  export enum SearchResultType {
    Lead = 'Lead',
    Loan = 'Loan',
    LoanApplication = 'LoanApplication',
  }

  // For Pipeline's "Type" dropdown.
  export enum PipelineType {
    Lead = 'Lead',
    LoanApplication = 'LoanApplication',
    /** @deprecated Backend-only value. The Active Loans pipeline UI was removed (ADO #86531) but the backend API still returns this value for tags and loan records. Do not use for new UI features. */
    Loan = 'Loan',
    ServicingLoan = 'ServicingLoan',
    Partners = 'Partners',
    AllLoans = 'AllLoans',
  }

  /** Our custom keys in local storage. */
  export enum LocalStorage {
    AuthType = 'auth-type',
    SecurityProfileAuthToken = 'profile-token',
    PipelineUi = 'pipeline-ui',
    LastLoanPipelineType = 'last-loan-pipeline-type',
    LastActivityDate = 'last-activity-date',
    LastFeatureFlagsPollingDate = 'last-feature-flags-polling-date',
    CreditUi = 'credit-ui',
    CcwUi = 'ccw-ui',
  }

  /** Our custom keys in local storage. */
  export enum AuthTypes {
    Default = null,
    Integrated = 'integrated',
  }

  export interface SecurityProfile {
    organizationId?: number;
    organizationCode?: string;
    organizationName?: string;
    securityProfileId?: number;
    securityProfileName?: string;
    userOrgProfileId?: number;
  }

  export interface SecurityProfiles {
    profiles?: SecurityProfile[];
  }

  export interface Session {
    id?: string;
    token?: string;
    expires?: Date;
  }

  /** Clear 2's custom version of MSAL's `AuthenticationResult` (from Azure AD SSO). */
  export interface Clear2AuthenticationResult extends AuthenticationResult {
    idTokenClaims: Clear2IdTokenClaims;
  }

  /** Clear 2's custom version of MSAL's `TokenClaims` (from Azure AD SSO). */
  export interface Clear2IdTokenClaims {
    ByteLogin?: string;
    UserID?: string;
    [key: string]: unknown;
  }

  /** The parsed version of a security profile token (header: x-profile-token). */
  export interface ParsedProfileToken {
    OrganizationId?: string;
    RawUserOrgProfileId?: string;
    SecurityProfileId?: string;
    UserId?: string;
    UserOrgProfileId?: string;
    /** Audience (who or what the token is intended for) */
    aud?: string;
    /** Expiration time (seconds since Unix epoch) */
    exp?: number;
    /** Issuer (who created and signed this token) */
    iss?: string;
    /** Not valid before (seconds since Unix epoch) */
    nbf?: number;
  }

  export interface CurrentUserInfo {
    userName?: string;
    guid?: string;
    losUserId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    userOrgProfileId?: number;
    securityProfileId?: number;
    securityProfileName?: string;
    organizationId?: number;
    organizationName?: string;
    changePasswordAtLogon?: boolean;
    // featurePermissions?: FeaturePermissions;
    nmlsid?: string;
  }

  export enum AppLaunchSetting {
    Dashboard = 'dashboard',
    Pipeline = 'pipeline',
  }

  export interface UserSettings {
    appLaunchSetting?: AppLaunchSetting;
    guid?: string;
    layoutPageSizes?: { [key: string]: number }; // Saved Page Size Setting per layoutGuid key that user has changed
  }

  export interface UserSettingsResponse {
    guid?: string;
    value?: string;
  }
}

export enum PrimeNgDialogRejectActionTypes {
  RejectButton = 1,
  RejectViaXicon = 2,
}

export enum ConfirmationModalCloseType {
  ClosedViaAcceptButton = 1,
  ClosedViaRejectButton = 2,
  ClosedViaReportButton = 3,
}

export interface ConfirmationModalData extends Confirmation {
  showReportButton?: boolean;
}

export enum CustomUiHeaders {
  skipSpinner = 'skipSpinner',
  skipResetSpinner = 'skipResetSpinner',
}

export enum SyncType {
  None = 0,
  FirstLien = 1,
  SecondLien = 2,
  ThirdLien = 3,
}

export const SyncTypeDisplay = ['', '1st', '2nd', '3rd'];

/**
 * API returns these Error codes we can match it generate different error messages.
 */
export enum ApiErrorCodes {
  NO_ACCESS_TO_LOAN_FILE = 'NO_ACCESS_TO_LOAN_FILE',
  MISSING_BACKGROUND_CHECK = 'MISSING_BACKGROUND_CHECK',
}

export enum BusinessChannel {
  Retail = 1,
  JV = 2,
  Wholesale = 3,
  Corr = 4,
  Bank = 5,
  EMP = 6,
}

export const propsToFilter = [
  'loanNumber',
  'loanStatus',
  'loanAmount',
  'propertyStreet',
  'propertyCity',
  'propertyState',
  'propertyZip',
  'borrowerFirstName',
  'borrowerLastName',
  'otherBorrowerFullNames',
];

export interface PageNotAllowedState {
  params?: PageNotAllowedParams;
}

export enum PageNotAllowedActions {
  GoBack = 1,
  ReturnToLoan = 2,
  GoToPipeline = 3,
}

export interface PageNotAllowedParams {
  title: string;
  message?: string;
  buttonText?: string;
  buttonAction?: PageNotAllowedActions;
  fileDataId?: number;
}

export enum CreditVendorCode {
  CreditPlusByXactus = 17,
  Xactus = 51,
  Birchwood = 76,
  ARC = 139,
  PartnersCredit = 251,
}
